import { useQueryClient } from "@tanstack/react-query";
import { buildTellescopeQueryKey, useTellescopeMutation } from "@tellescope/tanstack-query";
import { useCallback } from "react";
import type { InboxThread } from "@tellescope/types-models";

export const useInboxMessageDeleteMutations = () => {
  const queryClient = useQueryClient();

  const deleteSmsMutation = useTellescopeMutation({
    model: "sms_messages",
    method: "deleteOne",

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: buildTellescopeQueryKey({
          model: "sms_messages",
          method: "getSome-count",
        }),
      });
    },
  });

  const deleteChatMutation = useTellescopeMutation({
    model: "chats",
    method: "deleteOne",

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: buildTellescopeQueryKey({
          model: "chats",
          method: "getSome-count",
        }),
      });
    },
  });

  const deleteEmailMutation = useTellescopeMutation({
    model: "emails",
    method: "deleteOne",

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: buildTellescopeQueryKey({
          model: "emails",
          method: "getSome-count",
        }),
      });
    },
  });

  const deleteMessage = useCallback(
    (id: string, channel: InboxThread["type"]) => {
      switch (channel) {
        case "SMS":
          return deleteSmsMutation.mutateAsync(id);
        case "Chat":
          return deleteChatMutation.mutateAsync(id);
        case "Email":
          return deleteEmailMutation.mutateAsync(id);
      }
    },
    [deleteChatMutation, deleteEmailMutation, deleteSmsMutation]
  );

  return { deleteSmsMutation, deleteEmailMutation, deleteChatMutation, deleteMessage };
};
